import React from 'react';
import { theme, style } from 'constants';
import { lang } from 'lang';
import * as actions from 'actions';
import { IcoPM, IcoGroup, IcoSettings } from 'icons';
import { Link, Badge, isWeb } from 'core';

const styles = style({
  tab: {
    marginTop: isWeb ? 40 : 7,
    flexDirection: 'column',
    width: 70
  },
  badge: {
    position: 'absolute',
    right: 10,
    top: -6
  },
  title: {
    marginTop: 3
  }
});
const tabs = {
  SETTINGS: { icon: IcoSettings, action: actions.selectSettings },
  GROUPS: { icon: IcoGroup, action: actions.selectGroups },
  PM: { icon: IcoPM, action: actions.selectPM }
};

const Tab = ({ name, selected, selected_tab, unred_count }) => (
  <Link
    touchable_no_feedback
    content_style={styles.tab}
    title={lang[name]}
    icon={tabs[name].icon}
    onPress={tabs[name].action}
    color={theme.gray_color_lighten(0.7)}
    selected={selected || name === selected_tab}
    size={isWeb ? 14 : 10}
    title_style={styles.title}
    icon_size={26}
  >
    <Badge style={styles.badge} title={unred_count[name]} />
  </Link>
);
export default Tab;



// WEBPACK FOOTER //
// ./src/components/left/app_tabs.js